
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { Diamond } from "@/api/Diamond";
import useDiamondProperties from "@/composables/useDiamondProperties";
import { useI18n } from "vue-i18n";
import NoImageAvailable from "@/components/NoImageAvailable.vue";

export default defineComponent({
    name: "DiamondImage",
    components: { NoImageAvailable },
    props: {
        diamond: {
            type: Object as PropType<Diamond>,
            required: true
        }
    },
    setup(props) {
        const showIFrame = ref(false);

        const { videoLink } = useDiamondProperties(
            computed(() => props.diamond)
        );

        function handleIFrameLoaded() {
            showIFrame.value = true;
        }

        watch(videoLink, () => {
            showIFrame.value = false;
        });

        return { ...useI18n(), showIFrame, videoLink, handleIFrameLoaded };
    }
});
